<template>
  <global-modal name="event-modal-documents-issued-invoices">
    <Modal @close="$modal.hide('event-modal-documents-issued-invoices')">
      <EventDocumentsPopup tab="issuedInvoices" />
    </Modal>
  </global-modal>
</template>

<script>
import Modal from "@/components/Modal/Modal.vue";
import EventDocumentsPopup from "./EventDocumentsPopup.vue";

export default {
  name: "EventModalDocumentsIssuedInvoices",
  components: {
    Modal,
    EventDocumentsPopup
  }
};
</script>
